@if (envLabel) {
  <!-- 1. The Full-Screen Border Overlay -->
  <div [style.box-shadow]="'inset 0 0 0 6px ' + envColor" 
       style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; pointer-events: none; z-index: 999999; box-sizing: border-box;">
  </div>

  <!-- 2. The Floating Corner Ribbon -->
  <div [style.background-color]="envColor" class="environment-ribbon">
    {{ envLabel }}
  </div>
}
<div class="app-container">
  @if (authMessage !== '') {
    <div class="auth-message">
      {{ authMessage }}
    </div>
  }
  @else {
    <div class="sayka-app-shell" id="saykaAppShell" [class.sayka-sidebar-open]="!sidebarCollapsed">
      <app-sidebar [sidebarCollapsed]="sidebarCollapsed" [activeShellNav]="activeShellNav"
        [user]="user" (toggleCollapse)="toggleSidebar()" (closeMenu)="closeSidebar()">
      </app-sidebar>

      <div class="sayka-main-shell">
        <button class="sayka-sidebar-toggle" type="button" (click)="toggleSidebar()" aria-label="Toggle sidebar menu">
          Menu
        </button>
        @if (shellHeaderTitle) {
          <div class="shell-topbar">
            <h2>
              {{ shellHeaderTitle }}
            </h2>
          </div>
        }
        <p-toast [style.width]="'max-content'" position="bottom-center"/>
        <p-confirmDialog [style.width.%]="50"/>
        <div class="app-content">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  }
</div>